import React from 'react';
import  ScienceAssociation6to82024  from 'views/ScienceAssociation6to82024';
const BlogNewsroomPage = () => {

return <ScienceAssociation6to82024/>
};

export default BlogNewsroomPage;